<div [formGroup]="form" class="form-check text-start my-8 d-flex align-items-start autorizaciondatos">
    <input type="checkbox" value="remember-me" [id]="controlName" [name]="controlName"
        [formControlName]="controlName" required>
    <div class="estiloControlesModel">
        <!-- Texto por defecto -->
        <a *ngIf="!useAlternativeText" id="autoriza" class="" style="font-size: 12px; line-height: 1.5; display: block;" (click)="openModal()">
            <u>El propietario
                autoriza el
                tratamiento de sus datos personales a
                <strong>Suramericana S.A.</strong>
                y garantiza que cuenta con la autorización del tratamiento de datos del inquilino
                para las finalidades
                contenidas en la <strong>política de privacidad</strong>, donde también se encuentran los canales de
                contacto y la forma de ejercer sus derechos.
            </u>
        </a>
        
        <!-- Texto alternativo -->
        <a *ngIf="useAlternativeText" id="autoriza" class="" style="font-size: 12px; line-height: 1.5; display: block;" (click)="openModal()">
            <u>
                Autorizo a 
                <strong>Suramericana S.A.</strong>
                el
                tratamiento de los datos para las finalidades contenidas en la
                contenidas en la <strong>política de privacidad</strong>, donde también se
                encuentran los canales de contacto y la forma de ejercer mis derechos.
            </u>
        </a>
    </div>
</div>

